import * as yup from "yup";
import { ClientError } from "../../error";
import { Schema } from "../../schema";
import { SingleValueObject } from "../base-value-object";
export class MailAddress extends SingleValueObject {
    mailLocal;
    mailDomain;
    constructor(value) {
        super(value);
        this.mailLocal = value.mailLocal;
        this.mailDomain = value.mailDomain;
    }
    static fromOneLine(code) {
        try {
            const schema = MailAddress.schema();
            schema.mailAddress.validateSync(code);
        }
        catch (e) {
            if (yup.ValidationError.isError(e)) {
                throw new ClientError.InvalidValueObject(e.message);
            }
            throw e;
        }
        const [mailLocal, mailDomain] = code.split("@");
        return new MailAddress({
            mailLocal,
            mailDomain,
        });
    }
    validator(value) {
        return this.validate(value, MailAddress.innerSchema);
    }
    equals(t) {
        return this.mailLocal === t?.mailLocal && this.mailDomain === t?.mailDomain;
    }
    getValue() {
        return this.toString();
    }
    toString() {
        return `${this.mailLocal}@${this.mailDomain}`;
    }
    static isNotUndefined(args) {
        return !!args.mailLocal && !!args.mailDomain;
    }
    static schema(required = true) {
        return Schema.required({
            mailAddress: yup
                .string()
                .email()
                .matches(/^[\w\d_.-]+@[\w\d_.-]+\.[\w]{2,}$/)
                .label("メールアドレス"),
        }, required);
    }
    static innerSchema(required = true) {
        return Schema.required({
            mailLocal: yup
                .string()
                .required()
                .matches(/^[\w\d_.-]+$/)
                .label("メールローカル"),
            mailDomain: yup
                .string()
                .required()
                .matches(/^[\w\d_.-]+\.[\w]{2,}$/)
                .label("メールドメイン"),
        }, required);
    }
}
//# sourceMappingURL=mail-address.js.map